export class PointCloudManager {

  clouds = {};

  constructor(world){
    this.world = world;
  }

  clear(){
    for (const [key, cloud] of Object.entries(this.clouds)) {
      if(cloud.loaded){
        console.log('Deleted: ' + cloud.toString());
        this.world.scene().remove(cloud.points);
      } else {
        cloud.delete = true;
      }
    }
    this.clouds = {};
  }

  delete(filename){

    let cloud = this.clouds[filename];
    if(cloud.loaded){
      console.log('Deleted: ' + cloud.toString());
      this.world.scene().remove(cloud.points);
    } else {
      cloud.delete = true;
    }
    delete this.clouds[filename];

  }

}